<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
    </div>
  </div>
  <hr>
  <div class="row">
    <div *ngIf="isRemove" class="text-danger col-md-12">
      <input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
      <button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
      <button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
    </div>
    <div class="col-md-12" *ngIf="!isRemove">
      <table id="vTypes" border="1" class="table tbl-stl">
        <thead class="thead-inverse hgt-btn">
          <tr style="vertical-align:middle;" class="hgt-btn">
            <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">
              Code
              <i class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(1)"></i>
            </th>
            <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">
              Description
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
                (click)="utility.onSort(2)"></i>
            </th>
            <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">
              Download?
            </th>
            <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">
              Template?
            </th>
            <th style="vertical-align:middle;width:80px;padding:0px;" class="bfr-end-col">
              Active?
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
                (click)="utility.onSort(3)"></i>
            </th>
            <th style="vertical-align:middle;width:90px;padding:0px;" class="bfr-end-col">
              Sort Order
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
                (click)="utility.onSort(5)"></i>
            </th>
            <th style="vertical-align:middle;width:60px;padding:0px;" class="bfr-end-col">
              Group
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
                (click)="utility.onSort(4)"></i>
            </th>
            <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">Display</th>
            <th class="btn-show hgt-btn bfr-end-col end-col" style="width:103px!important;padding:1px 0;">
              <a [routerLink]="['/document/type/add']" title="">
                <span title="Add a New Document Type" class=" btn-add btn btn-primary btn-sm"><i
                    class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
              </a>
            </th>
          </tr>
        </thead>
        <tr style="height: 10px !important;"
          *ngFor="let vDocType of vDocTypes  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
          <td class="bfr-end-col">{{vDocType.code}}</td>
          <td style="width:40%!important;" class="bfr-end-col">{{vDocType.description}}</td>
          <td class="bfr-end-col">{{utility.isActive(vDocType.is_download)}}</td>
          <td class="bfr-end-col">{{utility.isActive(vDocType.is_template)}}</td>
          <td class="bfr-end-col">{{utility.isActive(vDocType.is_active)}}</td>
          <td class="text-center bfr-end-col">{{vDocType.sort_order}}</td>
          <td class="text-center bfr-end-col">{{vDocType.group_code}}</td>
          <td class="bfr-end-col">{{utility.showDisplayIndicator(vDocType.display_ind)}}</td>
          <td class="btn-show bfr-end-col end-col">
            <a [routerLink]="['/document/type/edit',vDocType.id]"><span title="Edit Document Type" style="margin: 0%"
                class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a>
            <span title="Delete Document Type" style="margin: 0%" class="btn btn-danger btn-sm"
              (click)="onConfirm(vDocType)"><i class="fa fa-trash-o fa-fw"></i></span>
          </td>
        </tr>
        <tfoot>
          <tr *ngIf="vDocTypes.length > 1" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id" style="">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="showNum" style="">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = $event"
                    style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>

          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No Document Types found.</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>